module.exports = __webpack_public_path__ + "img/chevron-left-double.7f835edf.svg";